import {
  DirectSalesCustomPOIFilter,
  DirectSalesCustomPOIFilterValue,
  DirectSalesFilterScope,
} from 'components/common/types/DirectSalesCampaign.types';
import { DirectSalesProductPoiFilter } from 'components/common/types/DirectSalesProductTemplate.types';
import { POI } from 'components/common/types/Planner.types';

export const getPoiPayloadName = (name: string | null | undefined, hasChildren: boolean): string | null => {
  return hasChildren || !name ? null : name;
};

export type PoiTransformInput = {
  include: boolean;
  radius: number;
  name: string | null | undefined;
  code: string;
  dataProvider: string;
  hasChildren: boolean;
};

export const transformPoiToFilter = (poi: PoiTransformInput): DirectSalesProductPoiFilter => {
  const { include, radius, name, code, dataProvider, hasChildren } = poi;

  return {
    type: 'PoiFilter',
    selectionType: include ? DirectSalesFilterScope.INCLUDE : DirectSalesFilterScope.EXCLUDE,
    radius,
    name: getPoiPayloadName(name, hasChildren),
    id: code,
    dataProvider,
  };
};

export const buildCustomPoiFilterValue = ({ name, poiPoints, radius }: POI): DirectSalesCustomPOIFilterValue => ({
  name,
  latitude: poiPoints?.[0]?.geometry.coordinates[1] ?? 0,
  longitude: poiPoints?.[0]?.geometry.coordinates[0] ?? 0,
  radius,
});

export const transformCustomPoiToFilter = (
  pois: POI[],
): {
  includedCustomPoiFilters: DirectSalesCustomPOIFilter[];
  excludedCustomPoiFilters: DirectSalesCustomPOIFilter[];
} => {
  return pois.reduce<{
    includedCustomPoiFilters: DirectSalesCustomPOIFilter[];
    excludedCustomPoiFilters: DirectSalesCustomPOIFilter[];
  }>(
    (acc, poiItem) => {
      const targetFilters = poiItem.include ? acc.includedCustomPoiFilters : acc.excludedCustomPoiFilters;
      const existingFilter = targetFilters.find((filter) => filter.name === poiItem.code);

      const value = buildCustomPoiFilterValue(poiItem);

      if (existingFilter) {
        existingFilter.values.push(value);
      } else {
        targetFilters.push({
          type: 'CustomPoiFilter',
          name: poiItem.code,
          values: [value],
        });
      }

      return acc;
    },
    { includedCustomPoiFilters: [], excludedCustomPoiFilters: [] },
  );
};
